module.exports = __webpack_public_path__ + "img/bg_1.2b2ea067.png";